export const AuthenticationAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    apiVersion: 2,
    storeKey: 'AuthenticationAPI'
};
export const AuthenticationLegacyAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'AuthenticationLegacyAPI'
};

export const LanguagesJsonAPI = {
    customEndPoint: process.env.REACT_APP_BLOB_STORAGE_LOCATOIN,
    url: 'languages.json',
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'LanguagesJsonAPI',
    apiVersion: 2,
    isBlobStorageAPI: true
};

export const CarePlanContentJsonAPI = {
    customEndPoint: process.env.REACT_APP_BLOB_STORAGE_LOCATOIN,
    url: 'careplancontent.json',
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'CarePlanContentJsonAPI',
    isBlobStorageAPI: true
};
export const GetMemberCarePlanAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    apiVersion: 2,
    storeKey: 'GetMemberCarePlanAPI'
};
export const GetMemberCarePlanLegacyAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'GetMemberCarePlanLegacyAPI'
};

export const GetMemberInfoAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    apiVersion: 2,
    storeKey: 'GetMemberInfoAPI'
};

export const GetMemberInfoSilentAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    apiVersion: 2,
    storeKey: 'GetMemberInfoSilentAPI'
};

export const GetAssessmentModulesAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    apiVersion: 2,
    storeKey: 'GetAssessmentModulesAPI'
};

export const SaveAllSNSEAssessmentAPI = {
    url: 'xp/assessments/saveall',
    method: 'POST',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    apiVersion: 2,
    storeKey: 'SaveAllSNSEAssessmentAPI'
};
export const AssessmentQuestionsAPI = {
    customURLNeeded: true,
    method: 'POST',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    apiVersion: 2,
    storeKey: 'AssessmentQuestionsAPI'
};

export const GetCommonListAPI = {
    customEndPoint: process.env.REACT_APP_BLOB_STORAGE_LOCATOIN,
    url: 'common.json',
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'GetCommonListAPI',
    apiVersion: 2,
    apiType: 'configuration',
    isBlobStorageAPI: true
};

export const SaveAssessmentAPI = () => {
    return {
        customURLNeeded: true,
        method: 'POST',
        saveOffline: true,
        responseSchema: null,
        requestSchema: null,
        queryParamsSchema: null,
        callErrorPage: false,
        storeKey: 'SaveAssessmentAPI',
        apiVersion: 2
    };
};
export const GetFullFillMentTemplateAPI = {
    customURLNeeded: true,
    method: 'POST',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'GetFullFillMentTemplateAPI',
    customEndPoint: `${process.env.REACT_APP_PROVISING_API_URL}/v1`,
    isFindRProvisionAPI: true
};

export const GetIntervensionHistoryAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'GetIntervensionHistoryAPI',
    apiVersion: 2
};
export const SendInterventionsAPI = {
    customURLNeeded: true,
    method: 'POST',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'SendInterventionsAPI',
    apiVersion: 2
};

export const UpoloadDocumentAPI = {
    customURLNeeded: true,
    method: 'POST',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'UpoloadDocumentAPI',
    apiVersion: 2,
    apiType: 'member'
};

export const GetUploadedDocDetailsAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'GetUploadedDocDetailsAPI',
    apiVersion: 2,
    apiType: 'member'
};
export const MemberInfoAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'MemberInfoAPI',
    apiVersion: 2,
    apiType: 'member'
};
export const GetUploadedDocumentsAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'GetUploadedDocumentsAPI',
    apiVersion: 2,
    apiType: 'member'
};

export const SendOtpAPI = {
    customURLNeeded: true,
    method: 'POST',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'SendOtpAPI',
    apiVersion: 2,
    apiType: 'member'
};

export const VerifyOtpAPI = {
    customURLNeeded: true,
    method: 'POST',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'VerifyOtpAPI',
    apiVersion: 2,
    apiType: 'member'
};

export const VerifyDateOfBirthAPI = {
    customURLNeeded: true,
    method: 'POST',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'VerifyDateOfBirthAPI',
    apiVersion: 2,
    apiType: 'member'
};

export const AssessmentAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'AssessmentAPI',
    apiVersion: 2,
    apiType: 'assessment'
};

export const GetAllResourcesAndProgramsAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'GetAllResourcesAndProgramsAPI',
    apiType: 'snse',
    apiVersion: 2
};

export const GetUserRolesAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'GetUserRolesAPI',
    apiVersion: 2,
    apiType: 'configuration'
};

export const GetRolePermissionsAPI = {
    customURLNeeded: true,
    method: 'GET',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'GetRolePermissionsAPI',
    apiVersion: 2,
    apiType: 'member'
};

const CommonAPIS = [
    AuthenticationAPI,
    AuthenticationLegacyAPI,
    LanguagesJsonAPI,
    CarePlanContentJsonAPI,
    GetMemberCarePlanAPI,
    GetMemberCarePlanLegacyAPI,
    GetMemberInfoAPI,
    SaveAllSNSEAssessmentAPI,
    AssessmentQuestionsAPI,
    GetCommonListAPI,
    GetMemberInfoSilentAPI,
    GetFullFillMentTemplateAPI,
    GetIntervensionHistoryAPI,
    SendInterventionsAPI,
    UpoloadDocumentAPI,
    GetUploadedDocDetailsAPI,
    MemberInfoAPI,
    SendOtpAPI,
    VerifyOtpAPI,
    VerifyDateOfBirthAPI,
    AssessmentAPI,
    GetAllResourcesAndProgramsAPI,
    GetUserRolesAPI,
    GetRolePermissionsAPI
];

export default CommonAPIS;
